import { Button } from '~/components/button'
import type { ViewProps } from 'react-native'
import * as Comp from './popover-header.styles'

type PopoverHeaderProps = ViewProps & {
  title: string
  tag?: React.ReactNode
  onClose: () => void
}

export function PopoverHeader({
  title,
  tag,
  onClose,
  testID,
  ...viewProps
}: PopoverHeaderProps) {
  return (
    <Comp.Header testID={testID} {...viewProps}>
      <Comp.Title numberOfLines={2}>{title}</Comp.Title>
      {tag}
      <Button.Root
        testID="popover-close-button"
        onPress={onClose}
        variant="neutral-tertiary"
        size="ml"
      >
        <Button.Icon symbol="rdicon-dismiss" />
      </Button.Root>
    </Comp.Header>
  )
}
